/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_TitleInputs */

const en_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm Sohan`)
};

const ar_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنا سوهان`)
};

const bn_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমি সোহান`)
};

const de_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin Sohan`)
};

const es_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soy Sohan`)
};

const fr_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je suis Sohan`)
};

const pt_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eu sou Sohan`)
};

const zh_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是索汉`)
};

const tr_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ben Sohan`)
};

const ru_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я Сохан`)
};

const pl_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jestem Sohan`)
};

/**
* | output |
* | --- |
* | "I'm Sohan" |
*
* @param {About_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_title = /** @type {((inputs?: About_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_title(inputs)
	if (locale === "bn") return bn_about_title(inputs)
	if (locale === "de") return de_about_title(inputs)
	if (locale === "es") return es_about_title(inputs)
	if (locale === "fr") return fr_about_title(inputs)
	if (locale === "pt") return pt_about_title(inputs)
	if (locale === "zh") return zh_about_title(inputs)
	if (locale === "tr") return tr_about_title(inputs)
	if (locale === "ru") return ru_about_title(inputs)
	if (locale === "pl") return pl_about_title(inputs)
	return en_about_title(inputs)
});